import axios from 'axios';

import authHeader from "@/services/auth-header";

const API_URL = process.env.VUE_APP_API_URL;

class AuthService {
    requestOTP(otp_form){
        return otp_form.post(`${API_URL}/users/otp`);
    }

    validateDoctorRequest(form){
        return  form.put(`${API_URL}/users/otp/validate`);
    }

    login(login_form){
        return login_form.post(`${API_URL}/users`);
    }

    sendDoctorCreationRequest(form){
        return form.post(`${API_URL}/doctors`);
    }

    updateDoctorInfo(edit_form,doctor_id){
        return edit_form.put(`${API_URL}/doctors/${doctor_id}`, {headers: authHeader()});
    }

    changeActiveStatus(status_form){
        //console.log(status_form.status);
        return status_form.put(`${API_URL}/doctors/status`, {headers: authHeader()});
    }

    setLiveCallSchedule(time_form){
        return time_form.post(`${API_URL}/doctorschedules`, {headers: authHeader()});
    }

    fetchdoctor(user){
        //console.log(`${API_URL}/users/${user}`);
        return axios.get(`${API_URL}/users/${user}`, {headers: authHeader()});
    }

    fetchDoctorTypes(){
        return axios.get(`${API_URL}/doctortypes`);
    }

    uploadImage(formData,doctor_id){
        let user = JSON.parse(localStorage.getItem(window.location.href.split('/')[3]+'User'));
        var Authorization= 'Bearer ' + user.token;
        return axios.post(`${API_URL}/doctors/${doctor_id}/image`, formData ,{headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': Authorization
            }
        });
    }
}

export default new AuthService();
